export const ALL_APPROVAL_CONTENT = 'ALL_APPROVAL_CONTENT';
export const FLAGGED_APPROVAL_CONTENT = 'FLAGGED_APPROVAL_CONTENT';
export const MSA_BASE_URL = 'https://m.media-amazon.com/images/G/01/zappos/zip/ApprovalUI/';
export const DEFAULT_PROFILE_IMAGE  = MSA_BASE_URL + '/Profile.png';

export const INFLUENCER_CONTENT = 'INFLUENCER_CONTENT';
export const BRAND_CONTENT = 'BRAND_CONTENT';
export const APPROVAL_TILE_NAME_MAX_CHAR = 18;
export const INFLUENCER_APPROVAL = 'INFLUENCER_APPROVAL';
